const authPrefix = 'AUTH_'

export default {
    LOADING: `${authPrefix}LOADING`,
}
